"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _apolloClient = require("apollo-client");

var _defaultCache = _interopRequireDefault(require("./defaultCache"));

var _createLink = _interopRequireDefault(require("./createLink"));

var _options = require("../options");

var _refreshJWT = _interopRequireDefault(require("./refreshJWT"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaultOptions = {
  endpointURL: 'http://localhost:3000',
  subscriptionsPath: '/subscriptions',
  useSubscriptions: true,
  saveSession: function saveSession() {
    throw new Error('You must pass a function to save the session');
  },
  getSession: function getSession() {
    throw new Error('You must pass a function to get the saved session');
  },
  cache: _defaultCache["default"],
  batchInterval: 20,
  batch: true,
  canRetry: true,
  promptTwoFactorCode: function promptTwoFactorCode() {
    return global.prompt('Please write your two factor code to continue');
  },
  onError: function onError() {},
  getHeaders: function getHeaders() {},
  resolvers: null,
  wsOptions: {},
  getJWT: function getJWT() {},
  upgradeJWT: function upgradeJWT() {},
  refreshJWT: function refreshJWT() {},
  refreshJWTEvery: 5 * 60 * 1000 // every 5 minutes

};

function _default(passedOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), passedOptions);

  (0, _options.setOptions)(options);
  var link = (0, _createLink["default"])(options);

  if (options.refreshJWT) {
    // initial upgrade
    if (options.upgradeJWT) {
      setTimeout(function () {
        var oldSession = options.getSession() || {};

        if (!options.getJWT() && oldSession.userId) {
          console.log('Performing initial JWT upgrade...');
          (0, _refreshJWT["default"])(options);
        }
      }, 1000);
    }

    setInterval(function () {
      return (0, _refreshJWT["default"])(options);
    }, options.refreshJWTEvery);
  }

  var client = new _apolloClient.ApolloClient({
    link: link,
    cache: options.cache,
    resolvers: options.resolvers
  });
  global.apolloClient = client;
  options.apolloClient = client;
  client._orionOptions = options;
  client._wsClient = options.wsClient;
  (0, _options.setOptions)(options);
  return client;
}